<template>
  <Modal
    centered
    :title="null"
    :visible="visible"
    :animated="false"
    :footer="null"
    :body-style="{ width: '720px', height: '446px', padding: 0 }"
    :maskStyle="{backgroundColor: 'rgba(10, 15, 26, 0.1)'}"
    wrap-class-name="modify-password-modal-wrapper"
    :width="720"
    destroy-on-close
    @change="$emit('change', $event)"
    @cancel='cancel'
  >
    <Tabs :active-key="activeTabKey" @change="handleTabChange" :class="tabClass">
      <TabPane key="0" :tab="$t('personSetting.ChangePassword')">
        <SchemaForm size="large" :formMetas="formMetas" />
      </TabPane>
      <TabPane key="1" :tab="$t('home.CancelAccount')" v-if="canCancel">
        <component
          :is="currentTabComponent"
          @termsAccept="termsAccept"
          @handleReason="handleReason"
          @goSuccess="goSuccess"
          @cancelComplete="cancelComplete"
          @getVerificationCode="getVerificationCode"
        />
      </TabPane>
    </Tabs>
  </Modal>
</template>
<script>
import { Modal, Tabs } from 'ant-design-vue'
import SchemaForm from '@/components/behavior/schema-form/index.vue'
import CancelAccountTerms from '@/components/business/cancel-account/terms.vue'
import CancelAccountReason from '@/components/business/cancel-account/reason.vue'
import CancelAccountVerification from '@/components/business/cancel-account/verification.vue'
import CancelAccountSuccess from '@/components/business/cancel-account/success.vue'
import { mapActions, mapState } from 'vuex'
import {
  // checkPassWordComplexity,
  checkBrowser,
  getSystemType
} from '@/utils/ops'
import MD5 from 'crypto-js/md5'
import axios from 'axios'
import Global from '@/global'
const reg = /^[^\u4e00-\u9fa5\s]+$/ // 正则 空格 和 中文
export default {
  name: 'ModifyPassowrdModal',
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  components: {
    Modal,
    SchemaForm,
    Tabs,
    TabPane: Tabs.TabPane,
    CancelAccountTerms,
    CancelAccountReason,
    CancelAccountVerification,
    CancelAccountSuccess,
  },
  data() {
    const _this = this
    return {
      formMetas: {
        schemas: [
          {
            get label() {
              return _this.$t('personSetting.OldPassword')
            },
            name: 'oldPassword',
            component: 'InputPassword',
            props: {
              allowClear: true,
              maxLength: 18,
              minLength: 6
            },
            wrapperClass: 'check-form-row',
            ifShow: () => this.existsOldPwd
          },
          {
            get label() {
              return _this.$t('personSetting.NewPassword')
            },
            name: 'newPassword',
            component: 'InputPassword',
            props: {
              allowClear: true,
              maxLength: 18,
              minLength: 6
            },
            wrapperClass: 'check-form-row'
          },
          {
            get label(){
              return _this.$t('personSetting.ConfirmAgain')
            },
            name: 'againPassword',
            component: 'InputPassword',
            props: {
              allowClear: true,
              maxLength: 18,
              minLength: 6
            },
            wrapperClass: 'check-form-row'
          }
        ],
        formProps: {
          layout: 'vertical',
          rules: {
            oldPassword: [
              { required: true, get message() { return _this.$t('personSetting.PleaseEnterOldPassword') }, trigger: 'blur' },
              { min: 6, get message(){ return _this.$t('home.Less6Char') } },
              {
                hocValidator: formModel => {
                  return async (rule, val) => {
                    const { newPassword, oldPassword, againPassword } = formModel

                    if (newPassword && newPassword === againPassword) {
                      // if (newPassword !== oldPassword) {
                      //   const data = {
                      //     // pwdComplexity: String(checkPassWordComplexity(newPassword).score)
                      //   }
                      //   for (const key in formModel) {
                      //     if (formModel[key] !== null) {
                      //       data[key] = MD5(formModel[key]).toString()
                      //     }
                      //   }
                      //   await this.modifyPassword(data)
                      // } else
                      if (newPassword === oldPassword) {
                        return Promise.reject(new Error(_this.$t('home.PasswordNotSame')))
                      }
                    }
                    return Promise.resolve()
                  }
                },
                trigger: 'submit'
              }
            ],
            newPassword: [
              { required: true, get message() { return _this.$t('personSetting.ConfirmPassword') }, trigger: 'blur' },
              { min: 6, get message(){ return _this.$t('home.Less6Char') } },
              {
                hocValidator: () => {
                  return (rule, val) => {
                    if (!reg.test(val)){
                      return Promise.reject('密码中不能包含中文和空格')
                    }
                    return Promise.resolve()
                  }
                },
                trigger: 'blur'
              }
            ],
            againPassword: [
              { required: true, get message() { return _this.$t('personSetting.ConfirmPassword') }, trigger: 'blur' },
              { min: 6, get message(){ return _this.$t('home.Less6Char') } },
              {
                hocValidator: formModel => {
                  return (rule, val) => {
                    if (val !== formModel.newPassword) {
                      return Promise.reject(_this.$t('home.PasswordMustBeSame'))
                    } else if (!reg.test(val)){
                      return Promise.reject('密码中不能包含中文和空格')
                    }
                    return Promise.resolve()
                  }
                },
                trigger: 'blur'
              }
            ]
          },
          colon: false
        },
        actions: { position: 'last', props: { class: 'modal-form-actions' } },
        onSubmit: this.handleSubmit,
        onReset: this.handleReset,
      },
      activeTabKey: '0',
      currentTab: 'Terms',
      canCancel: false,
      reason: {},
      verificationCode: undefined,
    }
  },
  computed: {
    ...mapState('user', ['existsOldPwd']),
    currentTabComponent() {
      return 'CancelAccount' + this.currentTab
    },
    tabClass() {
      return `modify-password-modal-title-tabs ${this.currentTab === 'Success' ? 'hidden-tabs' : ''}`
    }
  },
  methods: {
    ...mapActions(['doLogout']),
    ...mapActions('user', ['modifyPassword']),
    async handleSubmit(model, formRef) {
      try {
        const data = {
          // pwdComplexity: String(checkPassWordComplexity(model.newPassword).score),
          newPassword: MD5(model.newPassword).toString(),
          againPassword: MD5(model.againPassword).toString()
        }
        if (this.existsOldPwd) {
          data.oldPassword = MD5(model.oldPassword).toString()
        }
        this.modifyPassword(data).then(() => {
          this.$message.success(this.$t('home.PasswordChangedSucc'))
          this.$emit('change', false)
        }).catch(err => {
          formRef.fields[0].validateState = 'error'
          formRef.fields[0].validateMessage = err.message
        })
      } catch (err) {
        this.$message.error(err.message)
      }
    },
    handleReset() {
      this.$emit('change', false)
    },
    handleTabChange(val) {
      this.activeTabKey = val
    },
    termsAccept() {
      this.currentTab = 'Reason'
    },
    handleReason(reason) {
      this.getVerificationCode()
      this.reason = reason
      this.currentTab = 'Verification'
    },
    async goSuccess(verificationCode) {
      this.verificationCode = verificationCode
      const os = await getSystemType()
      const result = await axios.post(
        '/hiapigw/app/user/deregister',
        {
          code: verificationCode,
          device: `${checkBrowser()} browser`,
          os,
          // TODO: 每次发版，版本需要改动
          appVersion: Global.VERSION,
          reason: `${this.reason.checkboxList.join('；')}${this.reason.textarea ? '；' + this.reason.textarea : ''}`
        },
        {
          params: {
            _id: Global.genNonce(5)
          }
        }
      )
      if (result.data.code === 0) {
        this.$message.success(this.$t('home.AccountCancelSucc'))
        this.currentTab = 'Success'
      } else {
        this.$message.warn(result.data.msg)
      }
    },
    async cancelComplete() {
      await this.doLogout()
    },
    cancel() {
      if (this.activeTabKey === '1' && this.currentTab === 'Success') {
        this.doLogout()
      } else {
        this.activeTabKey = '0'
        this.currentTab = 'Terms'
      }
    },
    async getVerificationCode() {
      const result = await axios.get('/hiapigw/app/user/sendDeregisterCode?_id=' + Global.genNonce(5))
      if (result?.data?.code === 0) {
        this.$message.success(this.$t('home.VerifySendSucc'))
      } else {
        this.$message.warn(result.data.msg)
      }
    }
  },
  async created() {
    const result = await axios.post(
      '/hiapigw/app/user/userInfo',
      undefined,
      {
        params: {
          _id: Global.genNonce(5)
        }
      })
    if (result?.data?.code === 0) {
      this.canCancel = result.data.data.userInfo.enableDeregister
    }
  }
}
</script>
<style lang="less" scoped>
@import url(~@/styles/font.less);
::v-deep .modify-password-modal-wrapper {
  & > .ant-modal {
    padding-bottom: 0;
    & > .ant-modal-content {
      border-radius: 16px;
      box-shadow: 0px 5px 30px 0px rgba(89, 132, 219, 0.08);
      border: 1px solid #edeff2;
      overflow: hidden;

      & .ant-modal-body {
        &::before {
          content: " ";
          display: table;
        }
      }

      & > .ant-modal-header {
        position: absolute;
        width: 100%;
      }
    }
  }

  .ant-form {
    display: table;
    margin: 39px auto 0;

    .check-form-row.ant-form-item {
      margin-bottom: 19px;
    }
    .ant-form-item-with-help.check-form-row.ant-form-item {
      margin-bottom: 0px;
    }
    & > .ant-form-item {
      display: flex;
      & > .ant-form-item-label {
        flex-grow: 1;
        margin-right: 32px;
        height: 40px;
        line-height: 40px;
        text-align: right;
        & > label {
          .medium-font(16);
          color: #000;
        }
      }
      & > .ant-form-item-control-wrapper {
        width: 280px;
      }

      .ant-input-lg,
      .ant-input-affix-wrapper-lg {
        height: 40px;
        line-height: 40px;
      }
    }
  }
  .modal-form-actions {
    position: absolute;
    bottom: 48px;
    right: 56px;
    & > .default-btn {
      margin-right: 56px;
      color: #000;
    }
  }

  .modify-password-modal-title-tabs {
    & {
    display: flex;
    flex-direction: column;
    height: 100%;

    .ant-tabs-bar {
      flex-shrink: 1;
      margin-bottom: 0;
    }

    .ant-tabs-tab {
      .regular-font(18);
      margin: 0 0 0 56px;
      padding: 32px 0 11px 0;
      color: #333333;

      &.ant-tabs-tab-active {
        .medium-font(18);
        color: #236cff;
      }
    }

    .ant-tabs-ink-bar {
      height: 4px;
      background-color: #236cff;
    }

    .ant-tabs-content {
      flex-grow: 1;
    }
  }
  }
  .modify-password-modal-title-tabs.hidden-tabs {
    .ant-tabs-bar.ant-tabs-top-bar {
      height: 69px;
      border-bottom: none;
      .ant-tabs-nav-container {
        display: none;
      }
    }
  }
}
</style>
